<template lang="pug">
.robot-design.robot3
  #design-b1.banner
    .w 
      .p1
        b(:class="{fadeUp: isB1Visible}") 独具创新
        span(:class="{fadeDown: isB1Visible}") 多模态设计
      .p2.delay2(:class="{fadeDown: isB1Visible}") 伸缩、旋转形态自由切换，可静可动，造型由你定义
  #design-b2.banner
    .w
      .p1(:class="{fadeUp: isB2Visible}") 精于心，减于形
      .p2.delay2(:class="{fadeUp: isB2Visible}") 区别于传统机器人造型，融于家的简洁几何线条设计
  #design-b3.banner
    .w
      .p1(:class="{fadeUp: isB3Visible}") 不妥协，追求质感
      .p2.delay1(:class="{fadeUp: isB3Visible}") 高端布料和金属质感，让家别具一份精致
  #design-b4.banner
    .w
      .p1(:class="{fadeUp: isB4Visible}") 不止于形
      .p2.delay1(:class="{fadeUp: isB4Visible}") 深入考究人机交互
      .p3.delay1(:class="{fadeUp: isB4Visible}")
        |不止于外形，充分考虑躺，坐，站情况下的交互
        br
        |结合表情声音动作让人与机器人的交互更自然
      .face-list
        .item(
          v-for="(value,key) in face",
          :class="{active: key === currentFace}",
          @click="selectFace(key)",
          @mouseover="selectFace(key)",
        )
          .icon(:class="[key]")
          p {{value}}
      img.face-gif(src="../../../assets/web/face-laugh.gif", v-show="currentFace === 'laugh'")
      img.face-gif(src="../../../assets/web/face-angry.gif", v-show="currentFace === 'angry'")
      img.face-gif(src="../../../assets/web/face-cry.gif", v-show="currentFace === 'cry'")

</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      currentFace: 'laugh',
      face: {
        laugh: '开心',
        angry: '生气',
        cry: '哭泣'
      }
    }
  },
  computed: {},
  methods: {
    selectFace (face) {
      this.currentFace = face
    }
  },
  created () {
    $(window).on('scroll', () => {
      this.isB1Visible = isVisible('#design-b1')
      this.isB2Visible = isVisible('#design-b2')
      this.isB3Visible = isVisible('#design-b3')
      this.isB4Visible = isVisible('#design-b4')
    })
  },
}
</script>

<style lang="stylus">
@import 'config'
.robot-design.robot3
  .w
    position relative
    height 100%
    .p1
      font-size 42px
      line-height 1.8
    .p2
      font-size 16px
  #design-b1
    background-image url('../../../assets/web/3-design-b1.jpg')
    background-color #fff
    .w
      padding 350px 0 0 100px
    .p1
      b
        display inline-block
      span
        display inline-block
        font-size 33px
        padding-left 30px
  #design-b2
    background-image url('../../../assets/web/3-design-b2.jpg')
    background-color #000
    color #fff
    text-align center
    padding-top 90px
  #design-b3
    background-image url('../../../assets/web/3-design-b3.jpg')
    .w
      padding 370px 0 0 120px
  #design-b4
    background-image url('../../../assets/web/3-design-b4.jpg')
    color #fff
    .w
      padding 200px 0 0 700px
      text-align center
    .p3
      margin 20px 0
    .face-gif
      position absolute
      top 288px
      left 157px
    .face-list
      .item
        display inline-block
        vertical-align top
        margin 0 15px
        &.active
        &:hover
          .icon
            background-color #2e2e2e
            transform scale(.8) rotate(360deg)
        .icon
          width 88px
          height 88px
          transition all .5s
          margin-bottom 10px
          border-radius 100%
          border 1px solid #2e2e2e
          background-repeat no-repeat
          background-position 1px 1px
          &.laugh
            background-image url('../../../assets/web/icon-laugh.png')
          &.angry
            background-image url('../../../assets/web/icon-angry.png')
          &.cry
            background-image url('../../../assets/web/icon-cry.png')
        p
          font-size 14px

  .banner
    height 800px
    min-width 1200px
    background-size auto 100%
    background-position center
    background-repeat no-repeat
.is-mobile
  .robot3
    #design-b1, #design-b2, #design-b3, #design-b4
      width 100%
      min-width inherit
      height r(1100)
    #design-b1
      background-image url('../../../assets/mobile/3-design-b1.jpg')
      .w
        padding r(100) 0 0 0
        text-align center
      .p1
        span
          display block
          font-size r(34)
          padding 0 0 r(20)
    #design-b2
      background-image url('../../../assets/mobile/3-design-b2.jpg')
      padding-top r(140)
    #design-b3
      background-image url('../../../assets/mobile/3-design-b3.jpg')
      .w
        padding r(450) 0 0 r(50)
    #design-b4
      background-image url('../../../assets/mobile/3-design-b4.jpg')
      .w
        padding r(60) 0 0
      .p3
        margin r(20) 0
      .face-gif
        top r(575)
        left r(210)
        width r(340)
      .face-list
        .item
          margin 0 r(20)
          .icon
            width r(88)
            height r(88)
            background-size cover
          p
            font-size r(20)
  .robot-design
    .w
      .p1
        font-size r(46)
      .p2
        font-size r(24)
</style>



// WEBPACK FOOTER //
// src/views/robot/3/design.vue